import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from '@/store'
// import Home from '../views/Home.vue'
import loginRouter from './modules/login'
import homeRouter from './modules/home'
// import betHistoryRouter from '@/router/modules/bet-history'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home')
    // redirect: '/login'
  },
  loginRouter,
  homeRouter
  // betHistoryRouter
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  // if (!store.getters.isLogin) {
  //   if (to.path !== '/login') {
  //     next('/login')
  //   }
  // }
  next()
})

export default router
